import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";

import App from "./App";

// #root may already contain prerendered HTML (scripts/prerender.js) for
// crawlers; createRoot replaces it with the live app rather than hydrating,
// so prerender/client differences (e.g. env-dependent widgets) can't break.
const root = createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);